export default __webpack_public_path__ + "static/media/g2022-20.50f66c60.jpeg";